module.exports = __webpack_public_path__ + "img/Path 22@3x.af5d4ecc.png";